module.exports = __webpack_public_path__ + "static/media/dcu.b9acd359.png";